export * from "./StaticEmbeddingOptionCard";
